module.exports = __webpack_public_path__ + "static/media/404-error.62e63b8f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/404-error.png
 ** module id = 1610
 ** module chunks = 0
 **/